import React from "react";
import type { SectionComponentProps } from "../../registry.js";

interface GalleryItem {
  imageUrl?: string;
  alt?: string;
  caption?: string;
}

interface GalleryGridProps {
  headline?: string;
  items?: GalleryItem[];
}

const PLACEHOLDER_GRADIENTS = [
  "from-primary/30 to-accent/20",
  "from-accent/30 to-primary/10",
  "from-muted to-primary/20",
  "from-primary/20 to-muted",
  "from-accent/20 to-primary/30",
  "from-primary/10 to-accent/25",
];

const DEFAULT_ITEMS: GalleryItem[] = [
  { alt: "Dish one" },
  { alt: "Dish two" },
  { alt: "Dish three" },
  { alt: "Dish four" },
  { alt: "Dish five" },
  { alt: "Dish six" },
];

export function GalleryGrid({ props }: SectionComponentProps) {
  const {
    headline = "A Taste of What We Do",
    items = DEFAULT_ITEMS,
  } = props as GalleryGridProps;

  return (
    <section className="py-16 px-6 bg-muted/20" id="gallery">
      <div className="max-w-5xl mx-auto">
        {headline && (
          <h2 className="text-2xl md:text-3xl font-bold text-foreground text-center mb-10">
            {headline}
          </h2>
        )}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
          {items.map((item, i) => (
            <div
              key={i}
              data-stagger-child
              className="relative aspect-square overflow-hidden rounded-[var(--radius)] bg-muted"
            >
              {item.imageUrl ? (
                <img
                  src={item.imageUrl}
                  alt={item.alt ?? ""}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                />
              ) : (
                <div
                  className={`absolute inset-0 bg-gradient-to-br ${PLACEHOLDER_GRADIENTS[i % PLACEHOLDER_GRADIENTS.length]}`}
                />
              )}
              {item.caption && (
                <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/60 px-3 py-2">
                  <p className="text-xs text-white/90">{item.caption}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
